import { ApiService } from "@/api";

export const updateLeaderNote = (sampleId: string, leaderNote: string) => {
  return ApiService.baseAction(
    `/sample-detail/leader_note/${sampleId}`,
    {
      data: {
        leaderNote: leaderNote
      }
    },
    'post'
  )
}